import { render, staticRenderFns } from "./SymbolsLayout.vue?vue&type=template&id=7582aaa7&"
import script from "./SymbolsLayout.vue?vue&type=script&lang=js&"
export * from "./SymbolsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports